import React, { useEffect, useState } from 'react';
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { useRegion } from "./../../Context/RegionsContext"; // Import RegionContext

const Layout = ({ children, showFooter = true }) => {
    const [isSidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 992); // Mặc định hiển thị Sidebar ở màn hình lớn

    const toggleSidebar = () => {
        setSidebarVisible(!isSidebarVisible); // Đảo trạng thái của Sidebar
    };

    useEffect(() => {
        const handleResize = () => {
            // Cập nhật trạng thái hiển thị Sidebar khi kích thước màn hình thay đổi
            if (window.innerWidth >= 992) {
                setSidebarVisible(true); // Hiển thị Sidebar trên màn hình lớn
            } else {
                setSidebarVisible(false); // Ẩn Sidebar trên màn hình nhỏ
            }
        };

        // Lắng nghe sự kiện thay đổi kích thước
        window.addEventListener('resize', handleResize);

        // Dọn dẹp sự kiện khi component bị hủy
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const { selectedRegion, handleSelectRegion } = useRegion();

    // console.log("useRegion()", useRegion())
    useEffect(() => {
        // console.log("Selected Region in Layout:", selectedRegion);
    }, [selectedRegion]);

    // const handleSelectL = (language) => {
    //     setSelectedLanguage(language); // Cập nhật selectedLanguage
    // };
    // console.log("selectedLanguage", selectedLanguage)

    const handletoggleSidebar = (item) => {
        setSidebarVisible(item);
    }
    return (
        <div className={`app header-fixed sidebar-fixed aside-menu-fixed 
            ${isSidebarVisible && window.innerWidth < 992 ? 'sidebar-show' : ''} 
            ${isSidebarVisible && window.innerWidth >= 992 ? 'sidebar-lg-show' : ''}`}>
            <Header toggleSidebar={toggleSidebar} handleSelectRegion={handleSelectRegion} />
            <div className="app-body">
                <Sidebar isSidebarVisible={isSidebarVisible} toggleSidebar={toggleSidebar} /> {/* Truyền hàm toggle vào Sidebar */}
                <main style={{ marginTop: '30px' }} className="main">
                    {children}
                </main>
            </div>
            {showFooter && <Footer />} {/* Chỉ hiển thị footer nếu showFooter là true */}
        </div>
    );
};

export default Layout;
